import React, { useState } from "react";

const faqList = [
  {
    question: "What is Good Call?",
    answer:
      "Good Call is your safe space—a friend when the world feels too loud. It’s not therapy. It’s real people who listen, anytime you need to talk your heart out.",
  },
  {
    question: "Who can use the World Counseling Card?",
    answer:
      "Anyone looking for emotional support or guidance can use it. It's designed for universal access across age, background, or profession.",
  },
  {
    question: "How long is each session?",
    answer:
      "Each session typically lasts between 30–60 minutes depending on your plan and the type of service you choose.",
  },
  {
    question: "Can I choose my counselor?",
    answer:
      "Yes, you can select from a list of verified counselors based on language, availability, and specialization.",
  },
  {
    question: "Is everything confidential?",
    answer:
      "Absolutely. All conversations are private and encrypted. Your safety and trust are our top priority.",
  },
];

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(0); // First one open by default

  const toggleFaq = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    <div className="home-faq-section">
      <h2 className="home-faq-header">FAQs</h2>
      <div className="home-faq-list">
        {faqList.map((faq, index) => (
          <div
            key={index}
            className={`home-faq-item ${activeIndex === index ? "active" : ""}`}
            onClick={() => toggleFaq(index)}
          >
            <div className="home-faq-question">
              <span>{faq.question}</span>
              <span className="home-faq-toggle-icon">
                {activeIndex === index ? "−" : "+"}
              </span>
            </div>
            {activeIndex === index && (
              <div className="home-faq-answer">{faq.answer}</div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Faq;
